const React = require("react");
const Caption = require("../../../dumb/Caption/C");
const Button = require("../../../dumb/Button/C");

const WalletsList = require("./WalletsList");
const {pushLocation, backLocation} = require("../../../../router");
const {LINK_DEVELOPER_OPTIONS, LINK_CREATE_CRYPTO_WALLET} = require("../../../../constants/links");
const {COINS} = require("../../../../constants");
const ButtonBack = require("../../../dumb/Button/BackB");

module.exports = (props) => {
  const appId = props.params.appId;

  if (!appId) {
    pushLocation({
      path: LINK_DEVELOPER_OPTIONS
    })
    return <span />
  }

  const cryptoNames = COINS.reduce((acc, next) => {
    acc[next.id] = next.name;
    return acc;
  }, {});

  return (
    <div className={props.className || ''}>
      <div className="layoutRow fhaB fvaC fxwWrap">
        <div className="layoutRow fvaC">
          <ButtonBack
            className="m-10 mr10"
            onClick={() => {
              pushLocation({
                path: LINK_DEVELOPER_OPTIONS
              })
            }}
          />
          <div>
            <Caption className="fxUnset@m wsUnset@m">Crypto wallets</Caption>
            <span className="f11 cGrey">{appId}</span>
          </div>
        </div>
        <Button
          className="w170 mv-5 mv10@m"
          onClick={() => {
            pushLocation({
              path: `${LINK_DEVELOPER_OPTIONS}/${appId}${LINK_CREATE_CRYPTO_WALLET}`
            })
          }}
        >
          Add wallet
        </Button>
      </div>
      <WalletsList appId={appId} cryptoNames={cryptoNames} className="mt35" />
    </div>
  );
};